import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { WebAssetsContext } from "../../App";
import "react-tooltip/dist/react-tooltip.css";
import { Tooltip } from "react-tooltip";
import Swal from "sweetalert2";
import Addwallet from "../../components/admin/Addwallet";
import { filebasepath } from "../../functions/Function";
import "jquery/dist/jquery.min.js";
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import $ from "jquery";
import {
  alertDanger,
  apibaseURl,
  errorToast,
  successToast,
  getvalidationErr,
} from "../../functions/Function";
const Staff = (props) => {
  const WebAssets = useContext(WebAssetsContext);
  const api = WebAssets.apiURL;
  const navigate = useNavigate();
  const HandleClickOnEditUser = (id = "") => {
    navigate("/admin/staff/edit/" + id);
  };
  const [loading, setloading] = useState(true);
  const [users, setUsers] = useState([]);
  const fetchData = () => {
    fetch(apibaseURl + "getstaffs")
      .then((res) => res.json())
      .then((result) => {
        if (result.status == true) {
          setUsers(result.response);
          setloading(false);
          handleCallDataTable();
        }
      });
  };

  const HandleClickOnDelete = async (id = "") => {
    Swal.fire({
      title: "Are you sure you want to delete it ?",
      text: "Once deleted, you will not be able to get it again!",
      icon: "warning",
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      showCancelButton: true,
    }).then((result) => {
      if (result.isConfirmed) {
        try {
          const resJson = DeleteApi(id);
          resJson.then(function (output) {
            if (output.status == true) {
              Swal.fire({
                title: "Deleted!",
                text: "Staff user has been deleted successfully.",
                icon: "success",
              }).then((finalresult) => {
                if (finalresult.isConfirmed) {
                  fetchData();
                }
              });
            }
          });
        } catch (err) {
          console.log(err);
        }
      }
    });
  };
  const DeleteApi = async (id = "") => {
    const res = await fetch(apibaseURl + "deleteStaff", {
      method: "POST",
      body: JSON.stringify({ id: id }),
    });
    let resJson = await res.json();
    return resJson;
  };

  const handleCallDataTable = () => {
    $("#dataTable").DataTable().destroy();
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    setTimeout(function () {
      $("#theme-datatable").DataTable();
    }, 2000);
  }, [loading]);

  return (
    <>
      <div className="section-body">
        <div className="row">
          <div className="col-12">
            <div className="card">
              <div className="pt-4 pl-4 pr-4">
                <div className="card-header pl-0 pr-0 w-50 float-left">
                  <h4 className="headercolor">Staff Admin List</h4>
                </div>
                <div className="float-right">
                  <button
                    onClick={() => navigate("/admin/staff/add")}
                    className="btn btn-icon icon-left btn-primary"
                  >
                    <i className="fas fa-plus"></i> Add Staff
                  </button>
                </div>
              </div>
              <div className="card-body pl-4 pr-4 pb-4 pt-0">
                <div className="table-responsive theme-table">
                  <table
                    className="table table-hover table-bordered display"
                    id="theme-datatable"
                  >
                    <thead>
                      <tr>
                        <th className="text-center">S.NO</th>
                        <th>ID</th>
                        <th width={"180px"}>Name</th>
                        <th width={"180px"}>Email</th>

                        <th>Status</th>

                        <th className="text-right" width={"150px"}>
                          Action
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {users.length > 0 &&
                        users.map((user, i) => (
                          <tr key={i}>
                            <td className="text-center highlighter font-800">
                              {i + 1}
                            </td>
                            <td className="font-800 highlighter">#{user.id}</td>
                            <td className="font-800">{user.full_name}</td>
                            <td className="font-800">{user.email}</td>

                            <td>
                              {user.status == "1" ? (
                                <div className="badge badge-success">
                                  Active
                                </div>
                              ) : (
                                <div className="badge badge-danger">
                                  In-Active
                                </div>
                              )}
                            </td>
                            <td className="text-right">
                              <button
                                role="button"
                                id={"edit_" + user.id}
                                onClick={() => HandleClickOnEditUser(user.id)}
                                className="btn btn-icon btn-primary mr-2"
                                data-tooltip-content="Edit"
                              >
                                <i className="far fa-edit"></i>
                              </button>
                              <Tooltip anchorId={"edit_" + user.id} />

                              <button
                                role="button"
                                id={"delete_" + user.id}
                                onClick={() => HandleClickOnDelete(user.id)}
                                className="btn btn-icon btn-danger"
                                data-tooltip-content="Delete"
                              >
                                <i className="far fa-trash-alt"></i>
                              </button>
                              <Tooltip anchorId={"delete_" + user.id} />
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Staff;
